import { render, staticRenderFns } from "./NewDataSourceDialog.vue?vue&type=template&id=4e54b1c9&scoped=true&"
import script from "./NewDataSourceDialog.vue?vue&type=script&lang=js&"
export * from "./NewDataSourceDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewDataSourceDialog.vue?vue&type=style&index=0&id=4e54b1c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54b1c9",
  null
  
)

export default component.exports